export interface DataErrorNotificationMessages {
  title: string;
  text: string;
}

const DATA_ERROR_NOTIFICATION_MESSAGES = {
  nl: {
    title: 'Er is een fout opgetreden',
    text: 'De informatie is momenteel niet beschikbaar. Probeer het later opnieuw.',
  },
  fr: {
    title: "Une erreur s'est produite",
    text: "L'information n'est pas disponible pour le moment. Réessayez plus tard.",
  },
} as const satisfies Record<string, DataErrorNotificationMessages>;

export const getDataErrorNotificationMessages = (languageOrLocale: string = 'nl'): DataErrorNotificationMessages => {
  const isDutch = languageOrLocale === 'nl';
  return isDutch ? DATA_ERROR_NOTIFICATION_MESSAGES.nl : DATA_ERROR_NOTIFICATION_MESSAGES.fr;
};
